import idx from 'idx'
import axios from 'axios'
import {API_URL, SAUCE_API_URL} from 'config'

import initialState from 'reducers/initialState'
import errorDispatcher from 'utils/errorDispatcher'
import {getAuthorizationHeader} from 'utils/session'

// Actions
export const API_GET_OVERVIEW_DATA_REQUEST = 'API_GET_OVERVIEW_DATA_REQUEST'
export const API_GET_OVERVIEW_DATA_SUCCESS = 'API_GET_OVERVIEW_DATA_SUCCESS'
export const API_GET_OVERVIEW_DATA_ERROR = 'API_GET_OVERVIEW_DATA_ERROR'

// Reducer
export default function reducer(state = initialState.data, action) {
    switch (action.type) {
        case API_GET_OVERVIEW_DATA_REQUEST:
            return {
                ...state,
                overviewData: null
            }
        case API_GET_OVERVIEW_DATA_SUCCESS:
            return {
                ...state,
                overviewData: action.data
            }
        default:
            return state
    }
}

// Action Creators
export const getOverviewData = (organisation) => {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GET_OVERVIEW_DATA_REQUEST})
        try {
            let response = await axios.get(`${API_URL}/project/${organisation.uuid}/overview`, getAuthorizationHeader())
            response.data.organisationOverviewDetails.forEach(_ => _.percentageTrapsSynced = _.totalTraps === 0 ? 0 : (100 * _.totalTrapsSynced / _.totalTraps))
            dispatch({type: API_GET_OVERVIEW_DATA_SUCCESS, data: response.data})
        }
        catch (error) {
            console.error("getOverviewData", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_GET_OVERVIEW_DATA_ERROR, dispatch)
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/data.js